import { useState, useEffect } from "react";
import { useAppData } from "../context/AppDataContext"; 
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../utils/config";

function Login() {
  const { loadData } = useAppData();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [cookiesDisabled, setCookiesDisabled] = useState(false); // Added missing state
  const navigate = useNavigate();

  useEffect(() => {
    // 1. Initial Cookie Check
    if (!navigator.cookieEnabled) {
      setCookiesDisabled(true);
      setError("Your browser is blocking cookies. You will not be able to sign in.");
    }

    // 2. Infrastructure Warmup
    const baseUrl = API_BASE_URL.replace("/api/v0", "");
    fetch(`${baseUrl}/health`, { method: "GET" })
      .then(() => console.log("Infrastructure pre-warmed"))
      .catch((err) => console.log("Warmup ignored", err));
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    // Final check before sending the request
    if (!navigator.cookieEnabled) {
      setError("Cannot login: Cookies are still disabled in your browser.");
      return;
    }

    setError(""); 
    setLoading(true);

    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      const response = await fetch(`${API_BASE_URL}/auth/signin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
        credentials: "include" 
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || "Login failed");
      }
      
      await loadData();
      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Login</h2>

        {/* --- Unified Error Banner --- */}
        {error && (
          <div className={`error-banner ${cookiesDisabled ? "cookie-warning" : ""}`}>
            {error}
            {cookiesDisabled && (
              <p style={{ fontSize: "12px", marginTop: "5px", color: "#666" }}>
                Please enable cookies in your browser settings and refresh the page.
              </p>
            )}
          </div>
        )}

        {/* --- Single Form with Fieldset --- */}
        <form className="login-form" onSubmit={handleLogin}>
          <fieldset disabled={cookiesDisabled} style={{ border: 'none', padding: 0, margin: 0 }}>
            <input 
              type="text" 
              name="email" 
              placeholder="Email" 
              className={error && !cookiesDisabled ? "input-error" : ""} 
              required 
            />

            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              className={error && !cookiesDisabled ? "input-error" : ""}
              required
            />

            <div className="password-row">
              <span
                className="show-password-link"
                onClick={() => !cookiesDisabled && setShowPassword(p => !p)}
                style={{ cursor: cookiesDisabled ? 'not-allowed' : 'pointer' }}
              >
                {showPassword ? "Hide password" : "Show password"}
              </span>
            </div>

            <button 
              type="submit" 
              disabled={loading || cookiesDisabled} 
              style={{ marginTop: "10px" }}
            >
              {loading ? "Signing in..." : "Login"}
            </button>
          </fieldset>
        </form>

        <p>Don’t have an account? <Link to="/signup">Sign up</Link></p>
        <p>Forgot password? <Link to="/forgot-password">Click here</Link></p>
      </div>
    </div>
  );
}

export default Login;